import { render, staticRenderFns } from "./RowLabels.vue?vue&type=template&id=6f19aff9&scoped=true&"
import script from "./RowLabels.vue?vue&type=script&lang=js&"
export * from "./RowLabels.vue?vue&type=script&lang=js&"
import style0 from "./RowLabels.vue?vue&type=style&index=0&id=6f19aff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19aff9",
  null
  
)

export default component.exports